// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hKUK","footer":"styles_footer__1qCyi","passCodeTooltip":"styles_passCodeTooltip__3f7zm"};